import _objectSpread from "/data/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-36805753"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "initiator-modal"
};
const _hoisted_2 = {
  class: "toolbox"
};

const _hoisted_3 = /*#__PURE__*/_createTextVNode("查询");

const _hoisted_4 = /*#__PURE__*/_createTextVNode("重置");

const _hoisted_5 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_6 = /*#__PURE__*/_createTextVNode("确定");

import { computed, ref, watch } from 'vue';
import { getVexTableProps } from '@/config';
import { getSalesmanList } from '@/request';
export default {
  name: 'SelectInitiatorModal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    defaultSelected: {
      type: Array,
      default: () => []
    }
  },
  emits: ['update:modelValue', 'success'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const visible = computed({
      get() {
        return props.modelValue;
      },

      set(val) {
        emit('update:modelValue', val);
      }

    });
    const form = ref({
      linkMan: '',
      linkPhone: '',
      supplierKeyWd: ''
    });
    const table = ref();
    const tableData = ref([]);
    const selectedList = ref([]);
    watch(() => props.modelValue, val => {
      if (val) {
        var _table$value;

        resetForm();
        selectedList.value = props.defaultSelected.map(item => _objectSpread({}, item));
        (_table$value = table.value) === null || _table$value === void 0 ? void 0 : _table$value.commitProxy('reload');
      }
    });
    const tableOptions = getVexTableProps({
      columns: [{
        type: 'checkbox',
        width: '50px'
      }, {
        title: '登录账号',
        field: 'loginName',
        minWidth: '140px',
        showOverflow: true
      }, {
        title: '姓名',
        field: 'linkMan',
        minWidth: '120px',
        showOverflow: true
      }, {
        title: '手机号',
        field: 'linkPhone',
        minWidth: '140px',
        showOverflow: true
      }, {
        title: '所属团队',
        field: 'supplierName',
        minWidth: '180px',
        showOverflow: true
      }],
      proxyConfig: {
        ajax: {
          query: ({
            page
          }) => new Promise(resolve => {
            getSalesmanList({
              page: page.currentPage,
              rows: page.pageSize,
              linkMan: form.value.linkMan,
              linkPhone: form.value.linkPhone,
              supplierKeyWd: form.value.supplierKeyWd
            }).then(data => {
              tableData.value = data.rows || [];
              resolve({
                total: data.total,
                result: data.rows || []
              });

              if (selectedList.value.length) {
                setTimeout(() => {
                  var _table$value2;

                  const selectedRows = tableData.value.filter(item => selectedList.value.some(v => String(v.supAccountId) === String(item.supAccountId)));
                  (_table$value2 = table.value) === null || _table$value2 === void 0 ? void 0 : _table$value2.setCheckboxRow(selectedRows, true);
                }, 300);
              }
            });
          })
        }
      }
    });

    function tableSelectHandle({
      row,
      checked
    }) {
      const findIndex = selectedList.value.findIndex(v => String(v.supAccountId) === String(row.supAccountId));

      if (checked && findIndex === -1) {
        selectedList.value.push(row);
      } else if (!checked && findIndex > -1) {
        selectedList.value.splice(findIndex, 1);
      }
    }

    function tableAllSelectHandle({
      records,
      checked
    }) {
      if (checked) {
        records.forEach(item => {
          if (selectedList.value.some(v => String(v.supAccountId) === String(item.supAccountId))) {
            return;
          }

          selectedList.value.push(item);
        });
      } else {
        tableData.value.forEach(item => {
          const findIndex = selectedList.value.findIndex(v => String(v.supAccountId) === String(item.supAccountId));

          if (findIndex > -1) {
            selectedList.value.splice(findIndex, 1);
          }
        });
      }
    }

    function resetForm() {
      form.value = {
        linkMan: '',
        linkPhone: '',
        supplierKeyWd: ''
      };
    }

    function reset() {
      var _table$value3;

      resetForm();
      (_table$value3 = table.value) === null || _table$value3 === void 0 ? void 0 : _table$value3.commitProxy('reload');
    }

    function submit() {
      emit('success', selectedList.value);
      visible.value = false;
    }

    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");

      const _component_el_button = _resolveComponent("el-button");

      const _component_vxe_grid = _resolveComponent("vxe-grid");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _isRef(visible) ? visible.value = $event : null),
        title: "选择发起人",
        width: "70%",
        top: "50px"
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: _cache[4] || (_cache[4] = $event => visible.value = false)
        }, {
          default: _withCtx(() => [_hoisted_5]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: submit
        }, {
          default: _withCtx(() => [_hoisted_6]),
          _: 1
        })]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_input, {
          modelValue: form.value.linkMan,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.value.linkMan = $event),
          placeholder: "姓名",
          style: {
            "width": "160px",
            "margin-right": "10px"
          }
        }, null, 8, ["modelValue"]), _createVNode(_component_el_input, {
          modelValue: form.value.linkPhone,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.value.linkPhone = $event),
          placeholder: "手机号",
          style: {
            "width": "160px",
            "margin-right": "10px"
          }
        }, null, 8, ["modelValue"]), _createVNode(_component_el_input, {
          modelValue: form.value.supplierKeyWd,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.value.supplierKeyWd = $event),
          placeholder: "所属团队",
          style: {
            "width": "180px",
            "margin-right": "10px"
          }
        }, null, 8, ["modelValue"]), _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[3] || (_cache[3] = $event => table.value.commitProxy('reload'))
        }, {
          default: _withCtx(() => [_hoisted_3]),
          _: 1
        }), _createVNode(_component_el_button, {
          onClick: reset
        }, {
          default: _withCtx(() => [_hoisted_4]),
          _: 1
        })]), _unref(visible) ? (_openBlock(), _createBlock(_component_vxe_grid, _mergeProps({
          key: 0,
          ref_key: "table",
          ref: table
        }, _unref(tableOptions), {
          onCheckboxChange: tableSelectHandle,
          onCheckboxAll: tableAllSelectHandle
        }), null, 16)) : _createCommentVNode("", true)])]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }

};